import axios from 'axios'

export default {
    getIkidClass(){
        return axios.get('/ikidclass')
            .then(response => {
                return response.data
            })
    },
    getIkidGrade(class_id){
        return axios.get('/ikidgrade/class_id/' + class_id)
            .then(response => {
                return response.data
            })
    },
    getIkidGradeAll(){
        return axios.get('/ikidgrade')
            .then(response => {
                return response.data
            })
    },
    getIkidDataSource(params){
        return axios.get('/kid/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getIkidClassDataSource(params){
        axios.defaults.headers.common['Authorization'] = `AppKey gwg5f844b8tx7jgw63vp-h57cksh13nlgfeo639dm`
        return axios.get('/kid/datasource_class_dashboard', {params})
            .then(response => {
                return response.data
            })
    },
    getIkidQueue(params = {}){
        axios.defaults.headers.common['Authorization'] = `AppKey gwg5f844b8tx7jgw63vp-h57cksh13nlgfeo639dm`
        return axios.get('/kid/list_queue_usher_page', {params})
            .then(response => {
                return response.data
            })
    },
    getIkidbyID(id){
        return axios.get('/kid/' + id)
            .then(response => {
                return response.data
            })
    },
    createIkid(formdata){
        return axios.post('/kid', formdata)
            .then(response => {
                return response.data
            })
    },
    updateIkid(id,formdata){
        return axios.put('/kid/' + id, formdata)
            .then(response => {
                return response.data
            })
    },

    deactivateIkid(id){
        return axios.put('/kid/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateIkid(id){
        return axios.put('/kid/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },

    //SERVICE GET IKID CLASS
    getIkidClassDashboard(params){
        axios.defaults.headers.common['Authorization'] = `AppKey gwg5f844b8tx7jgw63vp-h57cksh13nlgfeo639dm`
        return axios.get('/kid/class_dashboard/ikidclass', {params})
            .then(response => {
                return response.data
        })
    },
    //SERVICE GET IKID PARENT
    getIkidParent(){
        return axios.get('/ikidparent')
            .then(response => {
                return response.data
            })
    },
    getIkidNote(id){
        return axios.get('/kid/' + id + '/get-note')
            .then(response => {
                return response.data
            })
    },
    createIkidNote(id, formdata){
        return axios.post('/kid/' + id + '/new-note', formdata)
            .then(response => {
                return response.data
            })
    },
    updateIkidNote(id,formdata){
        return axios.put('/kid/' + id + '/update-note', formdata)
            .then(response => {
                return response.data
            })
    },
    deleteIkidNote(id){
        return axios.delete('/kid/' + id + '/delete-note')
            .then(response => {
                return response.data
            })
    },
    graduate(id, formdata){
        return axios.post('/kid/' + id + '/graduate', formdata)
            .then(response => {
                return response.data
            })
    },
    getIkidDataSourceGraduate(params){
        return axios.get('/kid-graduate/datasource', {params})
            .then(response => {
                return response.data
            })
    },

    getIkidPeople(formdata){
        return axios.post('/kid-attendance/get-kid', formdata)
            .then(response => {
                return response.data
            })
    },

    checkinKid(formdata){
        return axios.post('/kid-attendance/checkin-kid/', formdata)
            .then(response => {
                return response.data
            })
    },
    scanKid(formdata){
        return axios.post('/kid-attendance/scan-kid', formdata)
            .then(response => {
                return response.data
            })
    },
    queuedKid(formdata){
        return axios.post('/kid-attendance/queued-kid', formdata)
            .then(response => {
                return response.data
            })
    },
    checkOutKid(formdata){
        return axios.post('/kid-attendance/checkout-kid/', formdata)
            .then(response => {
                return response.data
            })
    },
    getStatusKid(formdata){
        return axios.post('/kid-attendance/get-status-kid', formdata)
            .then(response => {
                return response.data
            })
    },
    getStatusKid(formdata){
        return axios.post('/kid-attendance/get-status-kid', formdata)
            .then(response => {
                return response.data
            })
    },
    getAllClass(formdata){
        return axios.post('/kid-attendance/get-status-all-class', formdata)
            .then(response => {
                return response.data
            })
    },
    getIkidActivity(params){
        return axios.get('/kid-attendance/get-status-all-kid-activity', {params})
            .then(response => {
                return response.data
            })
    },
    getKidsCheckManual(payload){
        return axios.post('/kid-attendance/kids-check-manual', payload)
            .then(response => {
                return response.data
            })
    },
    changeStatusKid(formdata){
        return axios.post('/kid-attendance/change-status-kid/', formdata)
            .then(response => {
                return response.data
            })
    },
    changeStatusKidInClass(formdata){
        return axios.post('/kid-attendance/change-status-kid-in-class/', formdata)
            .then(response => {
                return response.data
            })
    },
    cancelStatusKid(formdata){
        return axios.post('/kid-attendance/cancel-status-kid/', formdata)
            .then(response => {
                return response.data
            })
    },

    changeStatusKidQueue(formdata){
        axios.defaults.headers.common['Authorization'] = `AppKey gwg5f844b8tx7jgw63vp-h57cksh13nlgfeo639dm`
        return axios.post('/kid/class_dashboard/change-status-kid/', formdata)
            .then(response => {
                return response.data
            })
    },
    cancelStatusKidQueue(formdata){
        return axios.post('/kid/class_dashboard/cancel-status-kid/', formdata)
            .then(response => {
                return response.data
            })
    },
    scanKidForParentPage(formdata){
        axios.defaults.headers.common['Authorization'] = `AppKey gwg5f844b8tx7jgw63vp-h57cksh13nlgfeo639dm`
        return axios.post('/kid/class_dashboard/scan-kid', formdata)
            .then(response => {
                return response.data
            })
    },
    changeStatusKidForParentSelfCheckout(formdata){
        axios.defaults.headers.common['Authorization'] = `AppKey gwg5f844b8tx7jgw63vp-h57cksh13nlgfeo639dm`
        return axios.post('/kid/class_dashboard/change-status-kid/', formdata)
            .then(response => {
                return response.data
            })
    },
    kidLevelUp(class_list) {
        return axios.post('/kid-level-up', { class_list })
            .then(response => response.data);
    },
    getKidLevelUpList(year) {
        return axios.get(`/kid-level-up-list/${year}`)
            .then(response => response.data);
    }
}
